module.exports = __webpack_public_path__ + "img/project10_5.jpg.99b50146.webp";